import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as _ from 'underscore';

@Component({
  selector: 'app-viewers-modal',
  templateUrl: './viewers-modal.component.html',
  styleUrls: ['./viewers-modal.component.css']
})
export class ViewersModalComponent implements OnInit {
  @Input() viewerDetails;
  @Output() closeModal = new EventEmitter<any>()
  staffList = [];
  driverList = [];
  company;
  constructor() { }

  ngOnInit() {
    let viewers = this.viewerDetails.viewer;
    viewers = _.uniq(viewers).sort();
    const staff = this.viewerDetails.staff
    const driver = this.viewerDetails.driver
    const company = this.viewerDetails.company
    if (viewers) {
      for (let item of viewers) {
        if (staff[item]) {
          console.log(staff[item]);
          this.staffList.push(staff[item])
        } else if (driver[item]) {
          console.log(driver[item]);
          this.driverList.push(driver[item])
        }
        else {
          this.company = company
        }

      }
    }
  }

  onCloseModal(){
    this.closeModal.emit()
  }


}
